<ul class="sub-nav list-unstyled">
  <li [style.text-indent.em]="currentDepth">
    <a (click)="onSectionNavigate($event)" [href]="sectionUrl">{{
      section.title
    }}</a>
  </li>

  <li *ngIf="currentDepth < maxDepth">
    <rl-toc-submenu
      *ngFor="let childIdentifier of sections"
      [currentDepth]="currentDepth + 1"
      [maxDepth]="maxDepth"
      [sectionIdentifier]="childIdentifier"
      [containerStructure]="containerStructure"
      [sectionsById]="sectionsById"
    >
    </rl-toc-submenu>
  </li>
</ul>
